import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  delay?: number;
  as?: "div" | "section" | "li" | "article";
};

/**
 * Passthrough wrapper. Content renders visible immediately - no opacity-0
 * blanking, no IntersectionObserver, no transform animation - which keeps paint
 * fast and CLS at zero. `delay` is accepted for call-site compatibility but unused.
 */
export function Reveal({ children, className = "", as: Tag = "div" }: Props) {
  return <Tag className={className}>{children}</Tag>;
}
